// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__31a8I","modalForm":"UpgradeEpcsModal_modalForm__Ayqj2","modalFooter":"UpgradeEpcsModal_modalFooter__QO1yP"};